// src/components/artist-list/index.js
import { connect } from 'react-redux'
import { fetchArtists } from './actions'
import ArtistListContainer from './artist-list-container'
import { 
  getArtistList,
  getArtistEnabled
} from './selectors'
import {
  setArtistsEnabled
} from './actions'

const mapStateToProps = state => {
  return {
    artists: getArtistList(state),
    enabled: getArtistEnabled(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onStartup: () => {
      dispatch(fetchArtists())
    },
    onArtistClick: () => {
      dispatch(setArtistsEnabled(true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArtistListContainer)



// WEBPACK FOOTER //
// ./src/components/artist-list-container/index.js